import React from 'react';


import { Button} from 'reactstrap';

import {convertMetrics} from '../../helperFunctions/measurementSystem'

import ActivityDisplayModal from './ActivityDisplayModal'


function TableRow(props){
    const activity = props.activity.data
    //console.log(props.activity)
    const measurementSystem = props.measurementSystem
    return (
        
        <tr id={props.activity.id}>
            <td  className="text-warning" style={{padding: "5px"}}>
                {props.activity.activity_type}
            </td>
            <td  className="text-warning" style={{padding: "5px"}}>
                <ActivityDisplayModal type={props.activity.activity_type} name={props.activity.name} subType={props.activity.subType} id={props.activity.id} activity={props.activity.data}/>
            </td>
            <td  className="text-info" style={{padding: "5px"}}>
                {props.activity.name?.length>15 ? <>{props.activity.name.substring(0,15)}...</> :<>{props.activity.name}</>}
                
            </td>
            {activity.map((cell,key) =>{
                return(
                    <td className={colorText(key)}>
                        {cellFormat(cell,key,measurementSystem)}
                        <span style={{color:'rgb(255,170,255',fontSize:'7px'}}>{metrics(cell,key,measurementSystem)}</span>
                    </td>
                )
                
            })}
            <td  className="text-white" style={{padding: "35px"}}>
                {activity[5] !==0 ?
                 <input type="checkbox" checked={props.activity.counts} onClick={props.changeCountForFitness}></input>
                : <i class="fa fa-times" aria-hidden="true" style={{color:'rgb(235,130,170)'}}></i>}
               
            </td>
            <td  className="text-white">
                <Button color="danger" onClick={props.deleteEntry}>Delete
                </Button>
            </td>
        </tr>  
       
        
    )
}

function colorText(key){
    if (key === 5){
        return "text-success"
    }
    if (key === 6){
        return "text-warning"
    }
    if (key === 0){
        return "text-white"
    }
    if (key === 3){
        return "text-info"
    }
    else{
        return "text-white"
    }
}
function cellFormat(cell,key,measurementSystem){
    if (key === 0){
        var date = new Date(cell)
        date = String(date).split(" ")
        return `${date[0]} ${date[1]} ${date[2]} ${date[3]}`
    }
    if (key === 1){
        return `${(cell).toFixed(2)}`
    }
    if (key === 4){
        return `${(cell.toFixed(0))}`
    }
    if (key === 2){
        if (measurementSystem === "Metric km/hr" || measurementSystem === "Metric min/km"){
            return `${(cell/1000).toFixed(2)}`
        }
        else{
            return `${(cell*0.6/1000).toFixed(2)}`
        }
        
    }
    if (key === 3){
        return `${convertMetrics(cell.toFixed(2),measurementSystem)}` 
    }
    else{
        return cell
    }
    
}

function metrics(cell,key,measurementSystem){
    if (key === 0){
        var date = new Date(cell)
        date = String(date).split(" ")
        return `  ${date[4]}`
    }
    if (key === 2){
        if (measurementSystem === "Metric km/hr" || measurementSystem === "Metric min/km"){
            return " km"
        }
        else{
            return " miles"
        }
    }
    if (key === 1){
        return ` min`
    }
    if (key === 3){
        if (measurementSystem === "Metric km/hr"){
            return " km/hr"
        }
        else if(measurementSystem === "Metric min/km"){
            return " min/km"
        }
        else if(measurementSystem === "Imperial min/mile"){
            return " min/mile"
        }
        else if(measurementSystem === "Imperial mile/hr"){
            return " mile/hr"
        }
        else{
            return " ----"
        }
    }
    else{
        return ''
    }
}

export default TableRow;
